import * as React from "react";
import ToolTip from "react-tooltip";
import AnalyticsIcon from "../../utils/Icons/AnalyticsIcon";
import { AnalyticsLink, ClickableIconContainer } from "./AnalyticsRedirect.styles";
import { IAnalyticsLinkProps } from "./AnalyticsRedirect.types";
import { CourseCompletionAnalyticsContainer } from "./CourseCompletionAnalytics.container";

export const AnalyticsRedirect: React.FC<IAnalyticsLinkProps> = ({ courseId, objectId, isClass }) => {
  const part: string = isClass ? "class" : "scormPackage";
  const [showTooltip, toggleShowTooltip] = React.useState(false);
  const toggleTooltip = (value: boolean) => () => toggleShowTooltip(value);
  return (
    <>
      <AnalyticsLink
        data-for="analyticsLink"
        data-tip=""
        to={`/analytics/${part}/${courseId}/${objectId}`}
        onMouseEnter={toggleTooltip(true)}
        onMouseLeave={toggleTooltip(false)}
      >
        <ClickableIconContainer>
          <AnalyticsIcon />
        </ClickableIconContainer>
      </AnalyticsLink>
      <ToolTip id="analyticsLink" offset={{ bottom: 5 }} place="bottom">
        {showTooltip && (
          <CourseCompletionAnalyticsContainer isClass={isClass} courseId={courseId} objectId={objectId} />
        )}
      </ToolTip>
    </>
  );
};
